import { useEffect } from "react";
import { viewProfile } from "@/api/auth";
import { useAuthStore } from "@/stores/auth";

/**
 * Hydrate the auth store's display name from the authoritative
 * /user/v1/userprofile endpoint once per session. The JWT only carries the
 * login username (see extractUserFromToken), so without this the greeting
 * and header fall back to the username until the user opens their profile.
 * Runs once per mount of the authenticated shell; a failed lookup keeps the
 * token-derived identity.
 */
export function useSyncUserProfile() {
  useEffect(() => {
    let cancelled = false;
    viewProfile()
      .then((data) => {
        if (cancelled) return;
        const raw = data as Record<string, unknown>;
        const displayName = String(raw.displayName ?? "");
        if (!displayName) return;
        useAuthStore.setState((state) => {
          const user = state.user;
          if (!user || user.displayName === displayName) return state;
          return { user: { ...user, displayName } };
        });
      })
      .catch(() => {
        // Non-fatal — keep the token-derived identity.
      });
    return () => {
      cancelled = true;
    };
  }, []);
}
